import React from "react";
import Container from "../components/layout/Container";

const NotFoundPage: React.FC = () => (
  <Container>
    <div className="min-h-[60vh] flex flex-col items-center justify-center py-24">
      <h1 className="text-4xl font-bold mb-4">404 – Page Not Found</h1>
      <p className="text-lg text-neutral-600 mb-6">
        Sorry, the page you’re looking for doesn’t exist or has moved.
      </p>
      <a href="/" className="text-primary-600 underline font-medium">
        Go back home
      </a>
    </div>
  </Container>
);

export default NotFoundPage;